var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-modal',{attrs:{"name":"save-adapting-checklist-item","title":_vm.title,"ok-title":'COMMON.SAVE',"max-width53":"","error-message":_vm.firstError('name'),"ok-disabled":!_vm.canSubmit},on:{"ok":_vm.handleSubmit,"cancel":_vm.handleCancel}},[_c('template',{slot:"body"},[_c('item-form',{attrs:{"sections":_vm.sections,"form":_vm.form}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }